import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import logger from "js-logger";
import React from "react";
import layoutComponentsDictionary from "@/components/forms/components/layout/layoutComponentsDictionary";
export var FunctionDetailComponents = function (_a) {
    var fieldName = _a.fieldName, fieldDef = _a.fieldDef, record = _a.record, onUpdate = _a.onUpdate, moduleName = _a.moduleName;
    var componentIndex = 0;
    if (fieldName) {
        var componentName = fieldName || "";
        var functionComponentDetail = layoutComponentsDictionary.getLayoutComponent("".concat(componentName, "-detail"));
        if (functionComponentDetail) {
            logger.debug("[LAYOUT SETTINGS] - Utilisation du composant \"".concat(functionComponentDetail.name, "\" pour afficher le settings du type \"").concat(componentName, "\"."));
            return React.createElement(functionComponentDetail, {
                key: "function_edit_".concat(componentIndex++),
                fieldName: fieldName,
                fieldDef: fieldDef,
                record: record,
                onUpdate: onUpdate,
                moduleName: moduleName,
            });
        }
    }
    return _jsx(_Fragment, {});
};
